import { apiFetch } from "../../services/api-fetch";
import debounce from "../../services/helpers/debounce";

const searchFormInit = () => {
  let forms = Array.from(document.querySelectorAll('.search-form'));

  forms.forEach(form => {
    if (!form) return;

    let input = form.querySelector('[name="q"]');
    if (!input) return;

    let resultsContainer = form.querySelector('[data-results]');
    if (!resultsContainer) return;

    let fetchResults = debounce((formData) => {
      let data = new FormData();
      data.append('query', input.value);

      apiFetch(input.dataset.action, {
        method: 'POST',
        body: data
      })
      .then(res => {
        if (res.success) {
          resultsContainer.innerHTML = res.html;
        } else {
          resultsContainer.innerHTML = '';
        }
      })
      .catch(err => {
        resultsContainer.innerHTML = '';
        console.error(err);
      })
    }, 400);

    input.addEventListener('input', e => {
      fetchResults();
    });
  });

  document.addEventListener("click", function(e) {

    forms.forEach(form => {
      if (!form.contains(e.target)) { 
        form.classList.remove('opened');
      }
    });
  });
};

export { searchFormInit };